var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedInUser.attendant_id == undefined && !_vm.loggedInUser.onboarding)?_c('div',[_c('nuxt-child')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }